import React, { useState } from "react";
import "./team-form-page.css";
import { apiPostForm, apiPutForm, API_BASE } from "../../admin/api";

export default function TeamForm({ initial, onSaved, onCancel }) {
  const [name, setName] = useState(initial?.name || "");
  const [designation, setDesignation] = useState(initial?.designation || "");
  const [image, setImage] = useState(null);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      const body = { name, designation };
      if (image) body.image = image;

      if (initial?.id) {
        await apiPutForm(`/api/team/${initial.id}`, body);
      } else {
        await apiPostForm(`/api/team`, body);
      }
      onSaved?.();
    } catch (err) {
      alert(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="team-form-page minimalist">
      <section className="tf-left">
        <div className="card">
          <label className="f">
            <span className="f__label">Name</span>
            <input
              className="f__input"
              placeholder="Team member name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </label>

          <label className="f">
            <span className="f__label">Designation</span>
            <input
              className="f__input"
              placeholder="e.g., Senior Developer"
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
              required
            />
          </label>
        </div>

        <div className="card">
          <div className="card__title">Photo</div>
          <input
            className="f__input"
            type="file"
            accept="image/*"
            onChange={(e) => setImage(e.target.files?.[0] || null)}
          />
          {(initial?.image && !image) && (
            <div className="tf-preview">
              <img src={`${API_BASE}${initial.image}`} alt={initial.name} />
            </div>
          )}
        </div>
      </section>

      <aside className="tf-right">
        <div className="card slim">
          <div className="card__title">Actions</div>
          <div className="row end gap">
            <button type="button" className="btn btn--sm" onClick={onCancel}>Cancel</button>
            <button disabled={saving} className="btn primary">
              {saving ? "Saving..." : (initial ? "Save Changes" : "Add Member")}
            </button>
          </div>
        </div>
      </aside>
    </form>
  );
}
